export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12155.c5dc68cf.jpg";